import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default function getAppointmentDetail(leadId, callback) {
	var appointmentDetails;

	console.log('getAppointmentDetail', leadId);
	firebaseRef
		.ref('/client_appointments/' + PROJECT_CODE.projectCode + '/')
		.orderByChild('leadId')
		.equalTo(leadId)
		.once('value', (snapshot) => {
			var appointmentRef = snapshot.val();

			var appointmentDetailsKey =
				appointmentRef && Object.keys(appointmentRef);

			appointmentDetails =
				appointmentDetailsKey &&
				appointmentRef[appointmentDetailsKey[0]];

			console.log('this is the appointment details', appointmentDetails);
			callback(appointmentDetails);
		});
}
